import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, number, object, string } from "yup";
import { type AssetAllocationFields, createAssetAllocationSchema } from "../helpers";

export type SavingsFormType = AssetAllocationFields & {
  readonly investmentToolType: string;
  readonly partner?: string;
  readonly oneTimeDeposit: number;
  readonly regularAmount: number;
  readonly horizon: number;
  readonly appreciationRate: number;
  readonly stateContribution?: number;
  readonly note?: string;
};

export const getSavingsFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
  requireCharacteristics?: boolean,
) => ObjectSchema<SavingsFormType> = (t, requireCharacteristics) => {
  return object({
    investmentToolType: string().required(t(Resources.Validation.Required)),
    partner: string().optional(),
    oneTimeDeposit: number().required(t(Resources.Validation.Required)),
    regularAmount: number().required(t(Resources.Validation.Required)),
    horizon: number().required(t(Resources.Validation.Required)),
    appreciationRate: number().required(t(Resources.Validation.Required)),
    stateContribution: number().optional(),
    ...createAssetAllocationSchema(t, requireCharacteristics),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
  }).defined();
};
